import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';

export function initHistorySlider(query = document.querySelectorAll('.collectionHistory__slider')) {
    for (let slider1 of query) {
        let collectionHistory = slider1.closest('.collectionHistory');
        let descriptionWrapper = collectionHistory.querySelector('.collectionHistory__details');
        let slider2 = collectionHistory.querySelector('.collectionHistory__backgroundSlider');

        const updateDescription = (swiper) => {
            const activeSlide = swiper.slides[swiper.activeIndex];
            const activeSlideContent = activeSlide.querySelector('.historyItem');
            if (activeSlideContent) {
                descriptionWrapper.innerHTML = activeSlideContent.innerHTML;
            }
        };

        Swiper.use([Navigation]);
        const slider =
            new Swiper(slider1, {
            loop: false,
            slidesPerView: 1,
            autoplay: false,
            spaceBetween: 20,
            initialSlide: 0,
            navigation: {
                nextEl: slider1.querySelector('.swiper-button-next'),
                prevEl: slider1.querySelector('.swiper-button-prev'),
            },
            on: {
                init: updateDescription,
                slideChangeTransitionEnd: updateDescription
            }
        });

        if (slider2) {
            const backgroundSlider =
                new Swiper(slider2, {
                loop: false,
                slidesPerView: 3,
                autoplay: false,
                spaceBetween: 20,
                initialSlide: 1,
                allowTouchMove: false,
                centeredSlides:true,
            });
    // Hilfsfunktion für Index-Berechnung (mit/ohne loop)
            function getBgIndex(mainIndex, mainSwiper, bgSwiper, offset = 1) {
                if (mainSwiper.params.loop && bgSwiper.params.loop) {
                    const total = bgSwiper.slides.length - bgSwiper.loopedSlides * 2; // reale Anzahl
                    const real = mainSwiper.realIndex;
                    return (real + offset) % total;
                }
                // ohne loop: clampen
                const target = mainIndex + offset;
                return Math.max(0, Math.min(target, bgSwiper.slides.length - 1));
            }

    // Initiale Ausrichtung
            backgroundSlider.slideTo(getBgIndex(slider.activeIndex, slider, backgroundSlider, 1), 0);

    // Bei Wechsel im Hauptslider den Hintergrund mitführen
            slider.on('slideChange', () => {
                const targetBg = getBgIndex(slider.activeIndex, slider, backgroundSlider, 1);
                // ohne Animation kannst du 0 als Dauer setzen, sonst z. B. slider.params.speed übernehmen
                backgroundSlider.slideTo(targetBg, slider.params.speed || 0);
            });
        }
    }
}
